// Helper i18n mínimo para tenants con branding EN por host.
// Uso: t('Cargando…', 'Loading…')
// Regla: si el hostname es cad.retaliq.net (cement India demo),
// devuelve el string EN; en cualquier otro host devuelve el ES.
export const isEN = typeof window !== 'undefined'
  && window.location.hostname === 'cad.retaliq.net'

export function t(es, en) { return isEN ? en : es }
